import { useId, type ReactNode } from 'react';

export interface FieldProps {
  label: string;
  error?: string | undefined;
  hint?: string | undefined;
  /** Render prop receives the id and aria attributes for the control. */
  children: (control: {
    id: string;
    'aria-invalid': boolean;
    'aria-describedby': string | undefined;
  }) => ReactNode;
}

/** Label + control + inline error, wired with ids for screen readers. */
export function Field(props: FieldProps): React.JSX.Element {
  const id = useId();
  const errorId = `${id}-error`;
  return (
    <div className="field">
      <label className="field__label" htmlFor={id}>
        {props.label}
      </label>
      {props.children({
        id,
        'aria-invalid': Boolean(props.error),
        'aria-describedby': props.error ? errorId : undefined,
      })}
      {props.hint && !props.error && <span className="field__label">{props.hint}</span>}
      {props.error && (
        <span className="field__error" id={errorId} role="alert">
          {props.error}
        </span>
      )}
    </div>
  );
}
